import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { RoleToggleFilterComponent } from './role-toggle-filter.component';

@NgModule({
  declarations: [RoleToggleFilterComponent],
  imports: [CommonModule, MatButtonToggleModule],
  exports: [RoleToggleFilterComponent],
})
export class RoleToggleFilterModule {}
